import React, { useState } from 'react';
import Header from './Header';

const FAQ = ({ onBack }) => {
  const [expanded, setExpanded] = useState(null);

  const toggleExpand = (index) => {
    setExpanded(expanded === index ? null : index);
  };

  const faqData = [
    { question: 'Who can use Jackpot Concierge?', answer: 'Anyone who signs up!' },
    {
      question: 'How does your trip planning service work?',
      answer:
        'Our trip planning service ensures your Las Vegas visit is perfectly organized and stress free before you arrive. Simply provide a few details and payment. \n' +
        'One of our trip planners will contact you within 24 hours. Together, we’ll discuss your preferences and priorities. Our team will work with you to craft a personalized travel plan with unique recommendations based on our insider connections and local knowledge.\n' +
        'We’ll handle the bookings for you when possible. We will deliver a polished, easy-to-share itinerary for you and your group.',
    },
    {
      question: 'Do you offer group rates?',
      answer: 'Yes! We offer attractive discounts for group bookings of 10 or more guests. Please email us @ bookings@jackpotconcierge.com.',
    },

    {
      question: 'May I book for multiple people?',
      answer:
        'Yes! When you create a booking we will ask you how many are in your party.\n' +
        'Our concierge team will confirm booking details with you. The booking will be listed under the name of the person who booked the reservation.\n' +
        'The person who booked the reservation must be the one to check in at the restaurant, show, golf course, etc.',
    },
    {
      question: 'What if I want to book for someone else and I will not be present?',
      answer:
        'Whoever creates the booking must be present to check in.\n' +
        'You may not book on behalf of someone else.',
    },
    {
      question: 'Why wouldn’t I just use the hotel concierge?',
      answer:
        'Your hotel concierge may not exist any more. After the the Covid-19 pandemic concierge services were eliminated at many major resorts.\n' +
        'For those that still have concierge, many customers report long wait times and poor service.\n' +
        'Some concierge teams are trained to only recommend venues on property or within the same ownership group.\n' +
        'Jackpot Concierge recommends the best fit for your preferences with personalized and attentive service.',
    },
    {
      question: 'How are we different than other independent local concierge providers?',
      answer:
        'Our team at Jackpot has managed hospitality operations at a general manager and director level, including luxury Forbes 5 star and AAA 4 diamond properties.\n' +
        'You may find other concierge operations in town are simply focused on speed with a “one size fits all” approach.\n' +
        'We have developed the Jackpot app to create an efficient and seamless experience.',
    },
    {
      question: 'How specifically does the process work?',
      answer:
        'You may choose to make an individual booking or have access to unlimited bookings for a weekly or annual rate.\n' +
        'After you create a booking we will reach out to you make recommendations based on your preferences and when possible we will book on your behalf.\n' +
        'After booking you will have a dedicated concierge’s contact information that you can reach out to free of charge for the remainder of your trip for expert local knowledge and recommendations.',
    },
    {
      question: 'If I am booking on behalf of others, can I request Jackpot app access for the entire group I am booking for?',
      answer:
        'We do offer discounted group rates for groups of 10 or more.\n' +
        'Please fill out the group form on the bookings page or email us at bookings@jackpotconcierge.com.\n' +
        'We will be in touch shortly.',
    },
    {
      question: 'When can I expect a response to my booking?',
      answer:
        'We pride ourselves on responsive and personalized service.\n' +
        'You can expect a response within one hour during our business hours of 11a–11p (7 days a week).\n' +
        'Any bookings received outside our hours of operation will be handled by 12pm the following day.',
    },
    {
      question: 'Is any part of your service automated or provided by AI?',
      answer:
        'No! We are proudly human. Our luxury concierge team will give you personalized service.\n' +
        'After booking you may speak to our team any time during business hours.',
    },
    {
      question: 'What are your business hours?',
      answer: '11a–11p PST/PDT, 7 days a week',
    },
    {
      question: 'How do I contact you?',
      answer: 'Email us any time @ bookings@jackpotconcierge.com',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />

      <div className="px-4 py-8 sm:px-6 lg:px-8">

        <h1 className="text-2xl font-bold text-gray-800 text-center border-b-2 border-gray-200 pb-4 mb-6">
          Frequently Asked Questions
        </h1>

        <div className="space-y-4">
          {faqData.map((item, index) => (
            <div key={index} className="border border-gray-300 rounded-md">
              <button
                onClick={() => toggleExpand(index)}
                className="w-full text-left px-4 py-3 bg-gray-100 hover:bg-gray-200 font-semibold text-gray-800"
              >
                {item.question}
              </button>
              {expanded === index && (
                <div className="px-4 py-3 bg-gray-50 whitespace-pre-line text-gray-700">
                  {item.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQ;
